import { FreshworksHelper } from "app/helpers/freshworksHelper";
import {
  BetSlipStates,
  ProfileScreenTabs,
  TransactionDetailsStatus,
} from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import SegmentedControl from "../../components/SegmentedControl/SegmentedControl";
import { SessionHelper } from "../../helpers/sessionHelper";
import LoadSelectedComponent from "./components/LoadSelectedComponent/LoadSelectedComponent";
import ProfileHeaderNavigation from "./components/ProfileHeaderNavigation/ProfileHeaderNavigation";
import FetchTabContentHelper from "./helpers/FetchTabContentHelper/FetchTabContentHelper";
import GetTabsHelper from "./helpers/GetTabsHelper/GetTabsHelper";
import "./ProfileScreen.scss";
import "./ProfileScreenMobile.scss";

type Props = {
  history: any;
  loadAccount: (...args: Array<any>) => any;
  intl: Record<string, any>;
  account: any;
  isLoading: boolean;
};

const ProfileScreen = (props: Props) => {
  const [tab, setTab] = useState(ProfileScreenTabs.PERSONAL_DETAILS);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [updateFailed, setUpdateFailed] = useState(false);

  useEffect(() => {
    props.loadAccount();
    FreshworksHelper.showWidget();

    return () => {
      if (!isPublicView()) {
        FreshworksHelper.hideWidget();
      }
    };
  }, []);

  const handleSelectedTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }

    setTab(tabType);
    FetchTabContentHelper(tabType, props);
  };

  const showUpdateMessage = (type: string) => {
    setUpdateSuccess(type === TransactionDetailsStatus.SUCCESS);
    setUpdateFailed(type === BetSlipStates.FAILED);

    setTimeout(() => {
      setUpdateSuccess(false);
      setUpdateFailed(false);
    }, 3000);
  };

  return (
    <div
      className={`profile__component ${
        SessionHelper.isAsianSessionView() ? "profile__component-asian" : ""
      }`}
    >
      {/* Header component */}
      <ProfileHeaderNavigation history={props.history} />

      <div
        className={`profile__component__tabs  ${
          SessionHelper.isAsianRouteAndSessionView() ? "asia" : "europe"
        }`}
      >
        <SegmentedControl
          tabs={GetTabsHelper(
            { tab, updateSuccess, updateFailed },
            props,
            handleSelectedTab
          )}
          tabTypes={ProfileScreenTabs}
        />
      </div>
      <LoadSelectedComponent
        state={{ tab, updateSuccess, updateFailed }}
        data={props}
        showUpdateMessage={showUpdateMessage}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  account: state.profileModel.account,
  isLoading: state.profileModel.isLoading,
});

const mapDispatchToProps = (dispatch: any) => ({
  loadAccount: () => {
    dispatch.profileModel.loadAccount();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ProfileScreen));
